import InstructionsImage from "../../../assets/images/BPInstructions.png";
import ThirdPartyIntDetailsImage from "../../../assets/images/ThirdPartyIntDetails.png";
import { Roles } from "../../../constants/data/Roles";
import { useAuth } from "../../../context/AuthProvider";
import "./InstructionsPage.scss";
export function InstructionsPage() {
  const auth = useAuth();
  return (
    <div
      className={`instructions-wrapper ${
        auth?.authClaims?.role === Roles.supportUser ||
        auth?.authClaims?.role === Roles.superUser
          ? "support-wrapper"
          : "admin-wrapper"
      } `}
    >
      <div className="bp-verification-support">
        <div className="instructions-info pb-2">
          In order to use Inca Evo we need to connect your patient management
          system to our service. Follow the following steps to complete this
          connection.
        </div>
        <div className="instructions-info pb-2">
          If you encounter any problems please contact our{" "}
          <span
            className="support-link"
            onClick={() => {
              window.open(process.env.REACT_APP_SUPPORT_LINK);
            }}
          >
            support team.
          </span>
        </div>
      </div>
      <div className="register-clinic verify-bp">
        <div className="instructions">
          <div className="instructions-header pb-3">
            Approve the third-party integration of Inca Evo in Spectra SP1 Revision 2 and below
          </div>
          <div className="instructions-info pb-2">
            Please contact our support team for assistance with approving third-party integrations in these versions of Bp Premier or upgrade to the latest version of Bp Premier.
          </div>
          <div className="instructions-header pb-3 pt-4">
            Approve the third-party integration of Inca Evo in Spectra SP1 Revision 3 or later
          </div>
          <ol>
            <li className="instructions-info pb-2">
              Open Bp Premier on your computer.
            </li>
            <li className="instructions-info pb-2">
              From the main screen navigate to
              <b>{` Setup > Configuration.`}</b> The Configuration window will
              appear.
            </li>
            <li className="instructions-info pb-2">
              Click <b>Database</b> from the icons on the lefthand side, then
              click the
              <b> Setup third-party integrations</b> button. The Setup
              third-party integrations window will appear.
            </li>
            <li className="instructions-info pb-2">
              Click in the <b>Search for</b> text box and type “Precedence
              Health Care”.
            </li>
            <li className="instructions-info pb-2">
              Tick the box next to the option
              <b> Precedence Health Care (via Halo Connect).</b>
            </li>
            <img className="pb-4 w-100" src={InstructionsImage}></img>
            <li className="instructions-info pb-2">
              A popup will appear with the relevant details i.e Bp Site ID and the Pairing Code
            </li>
            <img className="pb-4 w-100" src={ThirdPartyIntDetailsImage}></img>
            <li className="instructions-info pb-2">
              Copy the <b>Bp Site ID and Pairing Code</b> from this popup and paste them into the respective fields on this page. <b>Please ensure that the credentials are not expired by checking that the Expiry date is in the future.</b>
            </li>
            <li className="instructions-info pb-2">
              Click <b>Close</b> to close the popup.
            </li>
            <li className="instructions-info pb-2">
              Click <b>Save</b>. The Setup third-party integrations window will
              close.
            </li>
          </ol>
        </div>
      </div>
    </div>
  );
}
